import React, { useState } from "react";
import { cloneDeep, isUndefined } from "lodash";

import FlexPackageDetails from "./FlexPackageDetails";
import TuitionTopUp from "./FlexPlanTopUp";
import FlexibleEarnings from "./FlexibleEarnings";
import SavestWithdraw from "./SavestWithdraw";
import ConfirmDetails from "./ConfirmDetails";
import SaveSuccessWithdraw from "./SaveSuccessWithdraw";
import FixedPayment from "../CreateSavestModal/SavestFixedPlan/FixedPayment";
import backicon from "../../../../../../Assets/backicon.svg";

const FlexPackageIndex = ({
  change,
  setChange: sc,
  data,
  balances,
  // getAsyncData,
}) => {
  const [pageData, setPageData] = useState([]);
  const setChange = (c, emit) => {
    if (!isUndefined(emit)) {
      const pd = cloneDeep(pageData);
      pd[c] = emit;
      setPageData(pd);
    }
    sc(c);
  };
  let currentModal;
  switch (change) {
    case 0:
      currentModal = <FlexPackageDetails setChange={setChange} data={data} />;
      break;

    case 1:
      currentModal = (
        <>
          <button
            className="backicon"
            onClick={() => {
              setChange(0);
            }}
          >
            <img src={backicon} alt="back icon" />
          </button>
          <FlexibleEarnings setChange={setChange} plan_id={pageData[1]} />
        </>
      );
      break;

    case 2:
      currentModal = (
        <>
          <button
            className="backicon"
            onClick={() => {
              setChange(0);
            }}
          >
            <img src={backicon} alt="back icon" />
          </button>
          <TuitionTopUp
            setChange={setChange}
            balance={balances}
            plan_id={data.id}
            name={data.name_of_plan}
            paymentData={pageData[2]}
          />
        </>
      );
      break;

    case 3:
      currentModal = (
        <>
          <button
            className="backicon"
            onClick={() => {
              setChange(0);
            }}
          >
            <img src={backicon} alt="back icon" />
          </button>
          <SavestWithdraw setChange={setChange} balance={data.wallet} />
        </>
      );
      break;

    case 4:
      currentModal = (
        <>
          <button
            className="backicon"
            onClick={() => {
              setChange(3);
            }}
          >
            <img src={backicon} alt="back icon" />
          </button>
          <ConfirmDetails
            setChange={setChange}
            {...{ ...pageData[4], ...data }}
          />
        </>
      );
      break;

    case 5:
      currentModal = (
        <>
          <button
            className="backicon"
            onClick={() => {
              setChange(0);
            }}
          >
            <img src={backicon} alt="back icon" />
          </button>
          <SaveSuccessWithdraw setChange={setChange} />
        </>
      );
      break;

    case 6:
      currentModal = (
        <>
          <button
            className="backicon"
            onClick={() => {
              setChange(2);
            }}
          >
            <img src={backicon} alt="back icon" />
          </button>
          <FixedPayment setChange={setChange} goBackTo={2} />
        </>
      );
      break;
    default:
  }

  return <div className="current-stage">{currentModal}</div>;
};

export default FlexPackageIndex;
